import React from "react";
import Profile from "./Profile.container";
import { ServicesAndSidebarContainer } from "./styled";
import Search from "./Search";
import { Row, Col } from "reactstrap";
import Portfolio from "./Portfolio.container";
import Feed from "./Feed/container";
import Aside from "./Aside/container";
import SEO from "./Seo.container";

const ClientPage = (props) => {
  return (
    <>
      <SEO />
      <Profile pageType="client" />
      <Search bg={props.cityPhoto} />
      <Portfolio type="client" />
      <ServicesAndSidebarContainer>
        <Row>
          <Col lg="8">
            <Feed />
          </Col>
          <Col lg="4">
            <Aside />
          </Col>
        </Row>
      </ServicesAndSidebarContainer>
    </>
  );
};

export default ClientPage;
